import React from 'react';
import './footer.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { FaFacebook, FaLinkedin, FaInstagram, FaYoutube } from 'react-icons/fa';





function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section quick-links">
          <h2>Quick Links</h2>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/advocacy">Advocacy</a></li>
            <li><a href="/leadership">CEOA Leadership</a></li>
            <li><a href="/payment-portal">Payment Portal</a></li>
            <li><a href="/aboutus">About Us</a></li>
            <li><a href="/contactus">Contact Us</a></li>

            {/* <li><a href="/findyouroptometrist">Find An Optometrist</a></li> */}
          </ul>
        </div>

        <div className="footer-section quick-links">
          <h2>Information</h2>
          <ul>
            <li><a href="/faq">FAQs</a></li>
            <li><a href="/termsandconditions"> Terms & Conditions</a></li>
            <li><a href="/privacypolicy">Privacy & Policies</a></li>
          </ul>
        </div>
{/* 
        <div className="footer-section contact">
          <h2>Contact Us</h2>
          <p>Email: <a href="mailto:eyecaredigitallibrary@gmail.com">eyecaredigitallibrary@gmail.com</a></p>
          <p>Email: <a href="mailto:eyecaredigitallibrary@gmail.com">eyecaredigitallibrary@gmail.com</a></p>
          <p>Phone: 0112 682 277</p>
          <p>Location: 932, Maradana Road, Colombo 08, Sri Lanka.</p>
        </div> */}

<div className="footer-section social-media">
  <h2>Follow Us</h2>
  <div className="social-icons">
    <a href="https://www.facebook.com/profile.php?id=100088345996110" 
       target="_blank"
       rel="noopener noreferrer" 
       className="social-icon">
      <i className="fab fa-facebook"></i>
    </a>
    <a href="https://www.linkedin.com/company/eye-care-institute" 
       target="_blank"
       rel="noopener noreferrer" 
       className="social-icon">
      <i className="fab fa-linkedin"></i>
    </a>
    <a href="https://www.instagram.com/eyecareinstitutesl" 
       target="_blank"
       rel="noopener noreferrer" 
       className="social-icon">
      <i className="fab fa-instagram"></i>
    </a>
    <a href="https://www.youtube.com/@eyecareinstituteslk" 
       target="_blank"
       rel="noopener noreferrer" 
       className="social-icon">
      <i className="fab fa-youtube"></i>
    </a>
  </div>
</div>


      </div>
      <div className="footer-bottom">
        <p>&copy; 2025 Ceylon Eye Care Optometric Association. All rights reserved. |  Designed and Developed by 
          <a 
            className="glaxmore-link" 
            href="https://www.glaxmore.com" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            &ensp; GLAXMORE
          </a>
        </p>
        
      </div>
    </footer>
  );
}

export default Footer;
